import {FC, useEffect, useState, PropsWithChildren} from 'react'
import {shallowEqual, useSelector, connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as auth from './AuthRedux'
import {getCurrentUser, getFeaturesPerTenant, refreshSession} from './AuthCRUD'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({auth: state.auth})
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsWithChildren<PropsFromRedux>> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  const accessToken = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)

  useEffect(() => {
    let cancelled = false

    const bootstrapAuth = async () => {
      try {
        if (!accessToken) {
          const {data} = await refreshSession()
          const refreshedToken = data?.token
          if (!refreshedToken) {
            props.logout()
            return
          }

          props.setAccessToken(refreshedToken)
        }

        const {data: user} = await getCurrentUser()
        if (cancelled) {
          return
        }
        props.fulfillUser(user)

        const {data: featuresPerTenant} = await getFeaturesPerTenant()
        if (cancelled) {
          return
        }
        props.setTenantFeatures(featuresPerTenant)
      } catch {
        if (!cancelled) {
          props.logout()
        }
      } finally {
        if (!cancelled) {
          setShowSplashScreen(false)
        }
      }
    }

    bootstrapAuth()
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
